import React from 'react';
import { StatsCard } from 'common/components';
import { StatsItemContainer } from 'features/command-center/components/shared';

import {
  StyledDivider,
  SummaryCardContainer,
  TitleHeadline
} from './RegionalDirectorSummaryCard.styled';

export const RegionalDirectorSummaryCard = ({
  detailsUrl,
  financeStats,
  healthStats,
  shouldShowPhoto = false,
  title,
  urlPhoto
}) => {
  return (
    <SummaryCardContainer>
      <StatsCard
        header={
          shouldShowPhoto && urlPhoto && <img src={urlPhoto} alt={title ?? 'Regional Director'} />
        }
        detailsUrl={detailsUrl}
      >
        <TitleHeadline variant="h5" component={detailsUrl && 'a'} href={detailsUrl}>
          {title}
        </TitleHeadline>
        <StyledDivider role="separator" />
        <StatsItemContainer items={healthStats} variant="stacked" />
        <StyledDivider role="separator" />
        <StatsItemContainer items={financeStats} variant="stacked" />
      </StatsCard>
    </SummaryCardContainer>
  );
};
